if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductCarousel = (context) => {
  const product_carousel = context.closest(".shopify-section");
  if (!product_carousel) return;

  const sliderContainer = product_carousel.querySelector(
    ".product-carousel__container",
  );

  const numOfSlides = sliderContainer.querySelectorAll(
    ".single-block.swiper-slide",
  ).length;
  let mobileSlidesPerView = 2;
  if (numOfSlides > 2) {
    mobileSlidesPerView = 2.14;
  }
  if (sliderContainer) {
    new Swiper(sliderContainer, {
      loop: false,
      slidesPerView: mobileSlidesPerView,
      navigation: {
        prevEl: sliderContainer.querySelector(
          ".product-carousel__navigation-prev",
        ),
        nextEl: sliderContainer.querySelector(
          ".product-carousel__navigation-next",
        ),
      },
      spaceBetween: 2,
      breakpoints: {
        768: {
          slidesPerView: "4",
          centerdSlides: true,
          spaceBetween: 24,
        },
      },
    });
  }
};

if (document.readyState != "loading") {
  [].forEach.call(
    document.querySelectorAll(".product-carousel__container"),
    (el) => {
      window.dAgency.initProductCarousel(el);
    },
  );
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(
      document.querySelectorAll(".product-carousel__container"),
      (el) => {
        window.dAgency.initProductCarousel(el);
      },
    );
  });
}
